import { Component } from "react";
import FormField from "../HumanResources/FormField";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { Typography } from "@mui/material";
import "./EPIFormQuestion.css";
import { canUpdateQuestion } from "../../redux/humanResources/humanResourcesStatusActions";
import { connect } from "react-redux";
import { isVisible } from "../../redux/humanResources/humanResourcesActions";

class EPIFormQuestion extends Component {
    responseValueChange(response, metaQuestion) {
        if (!metaQuestion) metaQuestion = this.props.metaQuestion;

        metaQuestion.response_lines[0] = response;
        this.props.responseValueChange(metaQuestion);
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        let visible = isVisible(this.props.sections, this.props.metaQuestion);
        if (!visible) return null;

        let question = this.props.metaQuestion.response_lines[0];
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding form-question">
                <Typography variant="h6">
                    {this.props.metaQuestion.question + (this.props.metaQuestion.is_require_answer ? " *" : "")}
                </Typography>
                <FormField
                    responseValueChange={this.responseValueChange.bind(this)}
                    id={this.props.metaQuestion.id.toString()}
                    metaQuestion={this.props.metaQuestion}
                    question={question}
                    visible={visible}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sections: state.equipmentEPI.equipmentEPIFormSections,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(EPIFormQuestion);
